import styled from "styled-components";

export const WaveWrapperSC = styled.div`
  height: var(--audio-track-width);
  width: 100%;

  canvas {
    top: auto;
    height: var(--audio-track-width) !important; /* Force canvas to follow wrapper */
  }
`;
